import ColorInput from "./ColorInput";

export default ColorInput;